import SpellsFilterAdvancedFilterOptions from './SpellsFilterAdvancedFilterOptions';

export default SpellsFilterAdvancedFilterOptions;
export { SpellsFilterAdvancedFilterOptions };
